import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { ExplainWithAIState } from "./utils/types/common";
import { ResourceExplorerFilterSchema } from "@/services/cloudchipr.api";

const initialState: ExplainWithAIState = {
  mode: null,
  billingData: null,
  currentBillingData: null,
  widgetData: null,
  newDataNeeded: false,
  anomalyTab: null,
};

export const explainWithAiSlice = createSlice({
  name: "dimensions",
  initialState: initialState,
  reducers: {
    // explain with ai
    resetExplainWithAI: () => initialState,

    setExplainWithAiMode: (
      state,
      action: PayloadAction<ResourceExplorerFilterSchema["mode"] | null>,
    ) => {
      state.mode = action.payload;
    },
    setExplainWithAiAnomalyTab: (
      state,
      action: PayloadAction<ExplainWithAIState["anomalyTab"]>,
    ) => {
      state.anomalyTab = action.payload;
    },
    setExplainWithAiNewDataNeeded: (state, action: PayloadAction<boolean>) => {
      state.newDataNeeded = action.payload;
    },
    setExplainWithCurrentBillingData: (
      state,
      action: PayloadAction<ExplainWithAIState["currentBillingData"]>,
    ) => {
      state.currentBillingData = action.payload;
    },
    setExplainWithAIBillingData: (
      state,
      action: PayloadAction<ExplainWithAIState["billingData"]>,
    ) => {
      state.billingData = action.payload;
    },
    setExplainWithAIWidgetData: (
      state,
      action: PayloadAction<ExplainWithAIState["widgetData"]>,
    ) => {
      state.widgetData = action.payload;
    },
  },
});

export const {
  resetExplainWithAI,
  setExplainWithAiMode,
  setExplainWithAIBillingData,
  setExplainWithAIWidgetData,
  setExplainWithCurrentBillingData,
  setExplainWithAiNewDataNeeded,
  setExplainWithAiAnomalyTab,
} = explainWithAiSlice.actions;

export default explainWithAiSlice.reducer;
